import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ImageComponent } from '@libs/common/components';
import { TopicCardsContentModel } from '@libs/cms/models';
import { HtmlDataLinkDirective } from '@libs/shared/ui';
import { HeadlinesComponent } from '../../items';
import { ContentBaseComponent } from '../content-base.component';

@Component({
  selector: 'ui-topic-cards',
  templateUrl: './topic-cards.component.html',
  styleUrls: ['./topic-cards.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ImageComponent,
    HeadlinesComponent,
    HtmlDataLinkDirective,
  ],
})
export class TopicCardsComponent extends ContentBaseComponent<TopicCardsContentModel> {}
